export default __webpack_public_path__ + "static/media/fondo.3c9675bd.jpg";